import React, { useState, useEffect } from 'react';
import './Hero.css';
import { Link } from 'react-router-dom';

// Importez vos images (assurez-vous que les chemins sont corrects)
import image1 from '../../../assets/images/divers/paysage/g1.jpg';
import image2 from '../../../assets/images/divers/paysage/g2.jpg'; // Nouvelle image
import image3 from '../../../assets/images/divers/paysage/g3.jpg'; // Nouvelle image
import image4 from '../../../assets/images/divers/paysage/g10.jpg'; // Nouvelle image
import image5 from '../../../assets/images/divers/paysage/g5.jpg'; // Déjà présente, juste pour l'ordre
import image6 from '../../../assets/images/divers/paysage/g6.jpg'; // Nouvelle image

const images = [image1, image2, image3, image4, image5, image6];

function Hero() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Gère le défilement automatique des images
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000); // Change l'image toutes les 5 secondes (5000 ms)
    return () => clearInterval(interval);
  }, []);

  // Fonction pour aller à l'image précédente
  const goToPrevious = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  // Fonction pour aller à l'image suivante
  const goToNext = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div
      className="hero-container"
      style={{ backgroundImage: `url(${images[currentImageIndex]})` }}
    >
      <div className="hero-overlay"></div>

      {/* Flèche Gauche */}
      <button className="slider-arrow left-arrow" onClick={goToPrevious}>
        &#10094; {/* Caractère HTML pour la flèche gauche */}
      </button>

      <div className="hero-content">
        <h1>IA ORA NA ET MAEVA</h1>
        <p>COULEUR SIRENE</p>
        <Link to="/catalogue" className="hero-cta-button">Découvrir les créations</Link>
      </div>

      {/* Flèche Droite */}
      <button className="slider-arrow right-arrow" onClick={goToNext}>
        &#10095; {/* Caractère HTML pour la flèche droite */}
      </button>
    </div>
  );
}

export default Hero;